module.exports = __webpack_public_path__ + "img/face-2.a40abd09.jpg";